export default "__VITE_ASSET__BZ73i1ID__"